import { Slot } from '@radix-ui/react-slot';
import React__default, { forwardRef } from 'react';
import { EMOJI_FONT_FAMILY } from '../../constants.mjs';

const Emoji = forwardRef(
  ({ emoji, style, asChild, ...props }, forwardedRef) => {
    const Component = asChild ? Slot : "span";
    return /* @__PURE__ */ React__default.createElement(Component, {
      role: "img",
      "aria-label": emoji,
      "data-emoji": emoji,
      style: {
        ...style,
        fontFamily: EMOJI_FONT_FAMILY,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "1em",
        whiteSpace: "nowrap"
      },
      ...props,
      ref: forwardedRef
    }, emoji);
  }
);

export { Emoji };
//# sourceMappingURL=Emoji.mjs.map
